import { Paginator } from '@app/classes';
import { Transaction } from '@app/models/payroll/company/transaction.model';
import { Table } from '@app/modules/table/classes/table.class';
import { AuthService } from '@app/services';
import { AmountColumn } from './columns/amount.column';
import { FailureCodeColumn } from './columns/failure-code.column';
import { MethodColumn } from './columns/method.column';
import { PayeeColumn } from './columns/payee.column';
import { PayorColumn } from './columns/payor.column';
import { StatusColumn } from './columns/status.column';
import { TypeColumn } from './columns/type.column';

export class TransactionsTable extends Table {
    constructor(
        public auth: AuthService,
        private payrollId: number
    ) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        this.columns = [
            new TypeColumn(),
            new MethodColumn(),
            new AmountColumn(),
            new PayeeColumn(),
            new PayorColumn(),
            new StatusColumn(),
            new FailureCodeColumn(),
        ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            Transaction.param('company', this.auth?.company?.id).param('payroll', this.payrollId)
        );
    }
}
